module.exports = __webpack_public_path__ + "img/goals-empty-icon.330b26c5.svg";